import React from 'react';

export const Logo = () => (
  <svg
    height="24"
    viewBox="0 0 128 141"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none">
      <path
        d="m56 2-48 27c-4.89637641 3.2426324-8 8.5702979-8 14v55c0 5.429702 3.10362359 10.757368 8 14l48 27c4.9460027 2.708226 11.0539973 2.708226 16 0l48-27c4.896376-3.242632 8-8.570298 8-14v-55c0-5.4297021-3.103624-10.7573676-8-14l-48-27c-4.9460027-2.70822571-11.0539973-2.70822571-16 0z"
        fill="#292f7c"
      />
      <path
        d="m70.0242225 5.59403143 47.8712255 27.26130367c3.775273 2.1499106 6.104552 6.1469726 6.104552 10.4754615v54.3384068c0 4.3284886-2.329279 8.3255506-6.104552 10.4754616l-47.8712255 27.261304c-3.7321883 2.125375-8.3162567 2.125375-12.048445 0l-47.8712259-27.261304c-3.77527271-2.149911-6.1045516-6.146973-6.1045516-10.4754617v-54.3384066c0-4.328489 2.32927889-8.325551 6.1045516-10.4754616l47.8712259-27.26130367c3.7321883-2.12537524 8.3162567-2.12537524 12.048445 0z"
        fill="#cddeff"
      />
      <path
        d="m64 127.744437v-22.530832-10.5698157-22.6191502c0-7.1878166 0-14.3756332 0-21.5634498 0-4.5467319 0-6.0965502 0-9.4302752-1.5427177 0-3.0829677.7321382-4.4678415 1.524104l-51.5321585 29.469621v25.274887c0 3.2544669 1.75697269 6.2554059 4.5949747 7.8482959l47.0047162 26.38241c1.3729528.770599 2.8761637 1.154518 4.4003091 1.152374 0-1.836331 0-3.044961 0-4.938169z"
        fill="#292f7c"
      />
      <path
        d="m120 127.744437v-22.530832-10.5698157-22.6191502c0-7.1878166 0-14.3756332 0-21.5634498 0-4.5467319 0-6.0965502 0-9.4302752-1.542718 0-3.082968.7321382-4.467842 1.524104l-51.532158 29.469621v25.274887c0 3.2544669 1.7569727 6.2554059 4.5949747 7.8482959l47.0047163 26.38241c1.372953.770599 2.876164 1.154518 4.400309 1.152469 0-1.836426 0-3.045056 0-4.938264z"
        fill="#3942b0"
        transform="matrix(-1 0 0 1 184 0)"
      />
      <path
        d="m68.375447 42.1837818 14.624553 8.6813629-14.6743211 7.9718478c-2.7588952 1.5595987-6.1373174 1.5500402-8.8873148-.0251447l-14.4383641-7.9467031 14.4209381-8.6593592c2.7676752-1.5998192 6.1789795-1.6082018 8.9545089-.0220037z"
        fill="#1a1e51"
      />
      <path
        d="m68.5069962 50.0061455c.3194632.1957327 2.8198302 1.7447285 7.501101 4.6469874l-7.6824183 4.1838596c-2.7588952 1.5595987-6.1373174 1.5500402-8.8873148-.0251447l-7.4357749-4.0978595c4.7368523-2.9805392 7.2419675-4.5498201 7.5153456-4.7078428.4100671-.2370341 2.8101779-1.5134039 4.4820652-1.4985056 1.6718873.0148982 4.0737982 1.2553173 4.5069962 1.4985056z"
        fill="#fee449"
      />
    </g>
  </svg>
);
